



  <div *ngIf="totalElements !== undefined && tab !== undefined && totalElements > 10 && tab === 1">
    <div [ngClass]="padding? 'paginationComp padding': 'paginationComp'">
      <div class="pag">
        <div class="leyenda">
          Items por página: {{pageSize}}
        </div>
        <div class="pages">
          {{page*pageSize - (pageSize-1)}} - {{page*pageSize}} de {{totalElements}}
          <i class="fa fa-chevron-left" [ngClass]="{'disabled':!prevBool()}" (click)="prev()"></i>
          <i class="fa fa-chevron-right" [ngClass]="{'disabled':!nextBool()}" (click)="next()"></i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="totalElementsTab2 !== undefined && tab !== undefined && totalElementsTab2 > 10 && tab == 2">
    <div [ngClass]="padding? 'paginationComp padding': 'paginationComp'">
      <div class="pag">
        <div class="leyenda">
          Items por página: {{pageSize}}
        </div>
        <div class="pages">
          {{page*pageSize - (pageSize-1)}} - {{page*pageSize}} de {{totalElementsTab2}}
          <i class="fa fa-chevron-left" [ngClass]="{'disabled':!prevBool()}" (click)="prev()"></i>
          <i class="fa fa-chevron-right" [ngClass]="{'disabled':!nextBool()}" (click)="next()"></i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="totalElementsTab3 !== undefined && tab !== undefined && totalElementsTab3 > 10 && tab == 3">
    <div [ngClass]="padding? 'paginationComp padding': 'paginationComp'">
      <div class="pag">
        <div class="leyenda">
          Items por página: {{pageSize}}
        </div>
        <div class="pages">
          {{page*pageSize - (pageSize-1)}} - {{page*pageSize}} de {{totalElementsTab3}}
          <i class="fa fa-chevron-left" [ngClass]="{'disabled':!prevBool()}" (click)="prev()"></i>
          <i class="fa fa-chevron-right" [ngClass]="{'disabled':!nextBool()}" (click)="next()"></i>
        </div>
      </div>
    </div>
  </div>







